<template>
  <div class="col col-12 pa-0 input-form">
    <span v-if="field.title" class="label d-flex align-center justify-space-between">
      <span>
        <b>{{field.title_not_to_trad ? field.title : $t(field.title)}}</b>
        <span v-if="field.props && field.props.required" style="color:red">&nbsp;*</span>
        <infoTooltip v-if="field.tooltip" :tooltip="field.tooltip" />
      </span>
      <v-btn small depressed color="primary" @click="reminderDialog = true">{{$t('addReminder')}}</v-btn>
    </span>
    <v-alert class="mt-2" border="left" v-if="!model[fieldName] || model[fieldName].length == 0" color="info" dense text>
        {{  $t('noRemindersSetted') }}
    </v-alert>
    <div class="mb-4" v-else>
      <div v-for="(remind, index) in model[fieldName]">
          <v-alert color="lightgrey" dense class="mb-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon  v-bind="attrs" small v-on="on" class="mr-2" color="primary">$eye_d</v-icon>
                </template>
              <span>
              <b>{{ $t('templateMsg') }} : </b><br>{{ remind.template }}</span>
            </v-tooltip>
            <span>{{ remind.timing }}h</span>
            <template v-slot:append>
              <v-btn text small class="square" color="error" @click="removeRemind(remind)">
                <v-icon small>$close</v-icon>
              </v-btn>
            </template>
          </v-alert>
      </div>
    </div>
    <v-dialog v-model="reminderDialog" width="600">
        <v-card>
            <v-toolbar tile flat dark  class="bg-gradient mb-4" height="64" style="height:80px;">
                  <div style="display:flex; width:100%; height:64px; align-items:center; justify-content:space-between;">
                      <div class="d-flex align-center">
                          <v-toolbar-title class="d-flex align-center">{{$t("addReminder")}}</v-toolbar-title>
                      </div>
                  </div> 
              </v-toolbar>
            <v-card-text class="pb-0">
                <v-form ref="reminderForm" v-model="validReminder">
                    <label class="label theme--light black--text"><b>{{ $t('reminderTiming') }}</b><span style="color: red">&nbsp;*</span></label>
                    <v-text-field class="input-form" dense solo flat type="number" min="1" :rules="ruleRemindTiming" v-model="reminderSmsConv.timing"></v-text-field>
                    <VVariableTextarea :model="reminderSmsConv" fieldName="template" :field="{ required:true, rules:[{'fonction': 'required', 'params': []}], props: { solo: true, flat: true, required:true }, title: 'reminderTemplate' }" :contexts="field.props && field.props.contexts ? field.props.contexts : ['contact', 'operation', 'today']" class="mb-0"/>
                </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="reminderDialog = false" depressed dense color="error">{{ $t('cancel') }}</v-btn>
              <v-btn @click="addRemind" depressed dense class="pt-0" color="primary">{{ $t('add') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <div v-if="field.jsonExample">
        <span><b>{{ $t('example') }} :</b></span>
       <pre>{{ field.jsonExample }}</pre>
    </div>
  </div>
</template>

<script>
import validate from '../functions/validations'
import infoTooltip from '@/components/infoTooltip';
import VVariableTextarea from '@/components/forms/inputs/v-custom-variable-textarea'

export default {
  props: ["model", "fieldName", "field"],
  components: { infoTooltip, VVariableTextarea },
  mixins: [validate],
  data() {
    return {
      reminderSmsConv: {
          timing:1,
          template : ""
      },
      reminderDialog : false,
      ruleRemindTiming: [
          value => !!value || this.$t('required'),
          value => value > 0 || this.$t('valueMustBeAtLeastOne')
      ],
      ruleTemplateRemind : [
          value => !!value || this.$t('required')
      ],
      validReminder: false
    };
  },
  watch: {
    reminderDialog(val) {
      if(!val){
        this.reminderSmsConv.timing = 1
        this.reminderSmsConv.template = ""
      }
    }
  },
  computed: {
    props() {
      if(this.field.props && this.field.props.placeholder && !this.field.props.placeholderAlreadyTranslated) {
        this.field.props.placeholderAlreadyTranslated = true;
        this.field.props.placeholder = this.$t(this.field.props.placeholder);
      }
      return this.field.props;
    }
  },  
  methods: {
    removeRemind(remind){
      let model = this._.cloneDeep(this.model[this.fieldName])
      model = model.filter((e) => e.timing != remind.timing && e.template != remind.template)
      this.$set(this.model, this.fieldName, model)
    },  
    addRemind(){
      if(this.$refs.reminderForm.validate()){
        let model = [];
        if(this.model[this.fieldName]) {
          model = this._.cloneDeep(this.model[this.fieldName])
        }
        model.push(this._.cloneDeep(this.reminderSmsConv))
        this.$set(this.model, this.fieldName, model)
        this.reminderDialog = false
      }
    }
  },
  };
</script>

<style lang="scss">
.input-form {
  .v-input__slot {
    background-color: var(--v-lightgrey-base) !important;
  }
}
</style>